import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IExhibitorOrdersPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const exhibitorOrdersSlice = createSlice({
    name: 'company-statistics/exhibitor-orders',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IExhibitorOrdersPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const exhibitorOrdersActions = exhibitorOrdersSlice.actions
export default exhibitorOrdersSlice.reducer
